module.exports = __webpack_public_path__ + "img/crm_case1.a92c3a93.png";